module.exports = __webpack_public_path__ + "img/logo_5.4076fca8.png";